// 3rd party
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class CriterionService {

  constructor(
    private http: Http
  ) { }

  getFromCalibration(identifier?: string) {
    return this.http
      .get('calibrations/criteria?identifier=' + identifier)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  getFromExternalCalibration(identifier?: string, customerIdentifier?: string) {
    return this.http
      .get('calibrations/externalCriteria?externalCalibrationIdentifier=' + identifier + '&customerIdentifier=' + customerIdentifier)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  getFromInstrument(instrumentIdentifier?: string, customerIdentifier?: string) {
    return this.http
      .get('instruments/criteria?instrumentIdentifier=' + instrumentIdentifier + '&customerIdentifier=' + customerIdentifier)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/criterion.service.ts